"use client";
import { cn } from "@/lib";
import { routes } from "@/routes";
import { signOut, useSession } from "next-auth/react";
import Link from "next/link";
import {
  BdBillList,
  BdBox,
  BdCalendar,
  BdLogout,
  BdPassword,
  BdUser,
  BdVerifiedCheck,
  BdWallet2,
} from "solar-icon-react/bd";
import { useTranslations } from "next-intl";
import { useModalStore } from "@/store";
import { useRouter } from "next/navigation";
import WalletBalanceSummary from "./walletBalanceSummary";
import { useState } from "react";

interface IProfileDropdownProps {
  pointerPosition?: "up" | "down";
  offSet?: number;
  pointerOffset?: string;
}

const ProfileDropdown = ({ pointerPosition }: IProfileDropdownProps) => {
  const t = useTranslations();
  const router = useRouter();
  const { setOpenModal } = useModalStore();
  const { data: session, status } = useSession();
  const [isBillsOpen, setIsBillsOpen] = useState(false);
  const openChangePassModal = () => {
    setOpenModal("create-password-modal");
  };
  const handleLogout = () => {
    signOut({
      callbackUrl: routes.main.HOME.primaryPath,
    });
  };
  return (
    <div
      className={cn(
        "shadow-main absolute z-50 w-[200px] cursor-default rounded-xl bg-gray-100 p-4",
        pointerPosition === "up" ? "top-14" : "bottom-20 md:bottom-25",
        `left-0`,
      )}
    >
      {/* Triangle pointer */}
      <div
        className={cn(
          "absolute h-4 w-4 rotate-45 bg-gray-100",
          pointerPosition === "up" ? "-top-2" : "-bottom-2",
          `left-5`,
        )}
      />

      <div className="mb-3 flex items-center gap-2 text-sm">
        <BdUser className="text-primary-main!" size={20} />
        <h2 className={cn("text-primary-main! text-left font-semibold")}>
          {session?.user.phoneNumber}
        </h2>
      </div>
      <WalletBalanceSummary />
      <ul className="flex flex-col gap-4 text-right">
        <li className="hover:text-secondary-main flex cursor-pointer items-center gap-2 text-sm transition-colors">
          <BdWallet2 className="text-primary-main!" size={20} />
          <Link
            title={t("wallet.title")}
            className={cn("text-primary-main!")}
            href={routes.main.WALLET.primaryPath}
          >
            {t("wallet.title")}
          </Link>
        </li>
        <li className="hover:text-secondary-main flex cursor-pointer items-center gap-2 text-sm transition-colors">
          <BdCalendar size={20} className="text-primary-main!" />
          <Link
            title={t("header.inquiryHistory")}
            className={cn("text-primary-main!")}
            href={routes.main.INQUIRY_HISTORY.primaryPath}
          >
            {t("header.inquiryHistory")}
          </Link>
        </li>
        <li
          id="user-dropdown-inquiry-history"
          className="hover:text-secondary-main flex cursor-pointer items-center gap-2 text-sm transition-colors"
        >
          <BdVerifiedCheck size={22} className="text-primary-main!" />
          <Link
            title={t("header.inquiryValidity")}
            className={cn("text-primary-main!")}
            href={routes.main.INQUIRY_VALIDITY.primaryPath}
          >
            {t("header.inquiryValidity")}
          </Link>
        </li>
        <li
          id="user-dropdown-paid-bills"
          className="flex flex-col gap-2 text-sm"
        >
          <button
            type="button"
            onClick={() => setIsBillsOpen((prev) => !prev)}
            className="hover:text-secondary-main flex cursor-pointer items-center gap-2 text-right transition-colors"
          >
            <BdBillList size={20} className="text-primary-main!" />
            <span className={cn("text-primary-main!")}>قبض‌ها</span>
          </button>
          {isBillsOpen && (
            <div className="border-primary-main/15 mr-7 flex flex-col gap-2 border-r pr-3 text-sm">
              <Link
                title="قبض‌های من"
                href={routes.main.MY_BILLS.primaryPath}
                className={cn("text-primary-main! hover:text-secondary-main")}
              >
                قبض‌های من
              </Link>
              <Link
                title="پرداخت سریع قبوض"
                href={routes.main.QUICK_BILL_PAYMENT.primaryPath}
                className={cn("text-primary-main! hover:text-secondary-main")}
              >
                پرداخت سریع قبوض
              </Link>
              <Link
                title="قبض‌های پرداختی"
                href={routes.main.BILL_HISTORY.primaryPath}
                className={cn("text-primary-main! hover:text-secondary-main")}
              >
                قبض‌های پرداختی
              </Link>
            </div>
          )}
        </li>
        <li className="hover:text-secondary-main flex cursor-pointer items-center gap-2 text-sm transition-colors">
          <BdBox size={20} className="text-primary-main!" />
          <Link
            title={t("header.packages")}
            className={cn("text-primary-main!")}
            href={routes.main.PACKAGES.primaryPath}
          >
            {t("header.packages")}
          </Link>
        </li>
        <li
          onClick={openChangePassModal}
          className="hover:text-secondary-main flex cursor-pointer items-center gap-2 text-sm transition-colors"
        >
          <BdPassword size={20} className="text-primary-main!" />
          <Link
            title={t("header.changePassword")}
            className={cn("text-primary-main!")}
            href="#"
          >
            {t("header.changePassword")}
          </Link>
        </li>
        <li className="hover:text-secondary-main flex cursor-pointer items-center gap-2 text-sm transition-colors">
          <BdLogout className="text-primary-main!" size={20} />
          <span className={cn("text-primary-main!")} onClick={handleLogout}>
            {t("auth.logout")}
          </span>
        </li>
      </ul>
    </div>
  );
};

export default ProfileDropdown;
